/* unplugin-vue-components disabled */import { render } from "./chatbot.vue?vue&type=template&id=3899713f"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"

import "./chatbot.vue?vue&type=style&index=0&id=3899713f&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__